import { type ComponentType } from 'react'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined'
import { type SvgIconProps } from '@mui/material'
import { yellow, indigo } from '../../../../colors'

export type ResultsAccessReason = 'permission' | 'insufficientResponses'

export interface ResultsAccessReasonPreset {
  Icon: ComponentType<SvgIconProps>
  badgeBackground: string
  badgeForeground: string
  title: string
  body: string
}

/**
 * Presets for the shared Results Access Card. `permission` is CE-125;
 * `insufficientResponses` is CE-210 (Results Threshold hide behavior).
 */
export const RESULTS_ACCESS_REASONS: Record<ResultsAccessReason, ResultsAccessReasonPreset> = {
  permission: {
    Icon: LockOutlinedIcon,
    badgeBackground: yellow[100],
    badgeForeground: yellow[500],
    title: "You don't have access to these results",
    body: "Your current role doesn't include permission to view results at this level. If you think this is a mistake, reach out to your administrator."
  },
  insufficientResponses: {
    Icon: ShieldOutlinedIcon,
    // Matches the standalone Results Access Card design (indigo tone).
    badgeBackground: indigo[100],
    badgeForeground: indigo[500],
    title: 'Not enough responses to show results',
    body: 'To protect respondent anonymity, results appear only after a minimum number of responses are collected for this group.'
  }
}
